import React, { useEffect } from "react";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import { track } from "@/lib/track";
import { useJourneyTracking } from "@/lib/useJourneyTracking";

const BASE_TITLE = "Raquel Tomaselli Lauria";

const PageShell = ({ path, title, sections = [], children }) => {
    useJourneyTracking([...sections, "footer"]);

    useEffect(() => {
        document.title = title ? `${title} — ${BASE_TITLE}` : `${BASE_TITLE} — Pesquisa aplicada sobre adaptação, complexidade sistêmica e criação de valor`;
        const canon = document.querySelector('link[rel="canonical"]');
        if (canon) canon.href = `https://raquellauria.com${path === "/" ? "/" : path}`;
        track("page_view", { path });
    }, [path, title]);

    return (
        <div className="min-h-screen bg-[#0E2018] text-[#F2EFE5] selection:bg-[#C7A659]/30">
            <SiteNav />
            <main>{children}</main>
            <div data-section-id="footer">
                <SiteFooter />
            </div>
        </div>
    );
};

export default PageShell;
